export const AddUpdate = '/add-update/:id?';

export const LANGUAGES_AVAILABLE = [
  { id: 'pt-br', label: 'Português', inlineIndex: 0 },
  { id: 'en', label: 'English', inlineIndex: 1 },
  { id: 'es', label: 'Español', inlineIndex: 2 },
];
